import { Observable } from 'rxjs/Observable';
import { RequestRecuperarChaveAcesso } from '../classes/request-recuperar-chave-acesso';
import { ResponseRecuperarChaveAcesso } from '../classes/response-recuperar-chave-acesso';
import { HttpService } from '../services/http.service';

export namespace LoginBi {

    export class Parser {
        public static fill(origin: any): ResponseRecuperarChaveAcesso {
            return Object.assign(new ResponseRecuperarChaveAcesso(), origin);
        }

        public static fillList(origin: any): Array<ResponseRecuperarChaveAcesso> {
            const items: Array<ResponseRecuperarChaveAcesso> = [];
            for (const item of origin) {
                items.push(Parser.fill(item));
            }
            return items;
        }
    }
    export class Rest {
        constructor(private httpService: HttpService) { }

        public recuperarChaveAcesso(request: RequestRecuperarChaveAcesso): Observable<any> {
            return this.httpService.pathV2().post('login/recuperar/chaveacesso', request);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/bi/login.bi.ts